import { createFileRoute } from '@tanstack/react-router';
import { LineGuidePage } from '@/features/messaging/pages/line-guide-page';

export const Route = createFileRoute('/_app/settings/line_/guide')({ component: LineGuidePage });
